import Vue from 'vue'
import Router from 'vue-router'
import PageNotFound from '@/views/common/page-not-found.view'
import AppRouter from './app/index'
import EvaluationRouter from './evaluation/index'
import LoginRouter from './login/index'
import DesignerRouter from './designer'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    ...LoginRouter,
    ...EvaluationRouter,
    ...AppRouter,
    ...DesignerRouter,
    {
      path: '*',
      name: 'Page not found',
      component: PageNotFound,
      meta: {
        title: 'Página no encontrada',
        access: ['*']
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js